import { render, staticRenderFns } from "./BOConsultationArchives.vue?vue&type=template&id=199358d0"
import script from "./BOConsultationArchives.vue?vue&type=script&lang=js"
export * from "./BOConsultationArchives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports